// src/detect.ts
function detectColorSupport() {
  const g = globalThis;
  const proc = g["process"];
  if (!proc?.env) {
    return { level: 0, hasBasic: false, has256: false, has16m: false };
  }
  const env = proc.env;
  if (env["NO_COLOR"] !== void 0) {
    return { level: 0, hasBasic: false, has256: false, has16m: false };
  }
  const forceColor = env["FORCE_COLOR"];
  if (forceColor !== void 0) {
    const level = forceColor === "" ? 1 : parseInt(forceColor, 10);
    if (!isNaN(level) && level >= 0) {
      return {
        level: Math.min(level, 3),
        hasBasic: level >= 1,
        has256: level >= 2,
        has16m: level >= 3
      };
    }
  }
  const colorTerm = env["COLORTERM"]?.toLowerCase();
  if (colorTerm === "truecolor" || colorTerm === "24bit") {
    return { level: 3, hasBasic: true, has256: true, has16m: true };
  }
  const term = env["TERM"]?.toLowerCase() ?? "";
  if (term.includes("256color") || term.includes("256-color")) {
    return { level: 2, hasBasic: true, has256: true, has16m: false };
  }
  if (term.includes("color") || term.includes("ansi") || term.includes("xterm") || term.includes("vt100") || term.includes("screen") || term.includes("linux")) {
    return { level: 1, hasBasic: true, has256: false, has16m: false };
  }
  if (env["CI"]) {
    return { level: 1, hasBasic: true, has256: false, has16m: false };
  }
  if (proc.stdout?.isTTY) {
    return { level: 1, hasBasic: true, has256: false, has16m: false };
  }
  return { level: 0, hasBasic: false, has256: false, has16m: false };
}
function detectTerminalBackground() {
  const g = globalThis;
  const proc = g["process"];
  if (!proc?.env) {
    return "unknown";
  }
  const env = proc.env;
  const colorFgBg = env["COLORFGBG"];
  if (colorFgBg) {
    const parts = colorFgBg.split(";");
    const bg = parseInt(parts[parts.length - 1] ?? "", 10);
    if (!isNaN(bg)) {
      return bg < 7 || bg >= 8 && bg < 16 && bg !== 15 ? "dark" : "light";
    }
  }
  const termBackground = env["TERM_BACKGROUND"]?.toLowerCase();
  if (termBackground === "dark" || termBackground === "light") {
    return termBackground;
  }
  return "dark";
}
function createAutoEnvironmentAdapter() {
  const colorSupport = detectColorSupport();
  return {
    get: (name) => {
      const g = globalThis;
      const proc = g["process"];
      return proc?.env?.[name];
    },
    getColorSupport: () => colorSupport,
    getTerminalBackground: detectTerminalBackground
  };
}

export { createAutoEnvironmentAdapter, detectColorSupport, detectTerminalBackground };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map